import { render, staticRenderFns } from "./common-yzm.vue?vue&type=template&id=1c14ade0&scoped=true&"
import script from "./common-yzm.vue?vue&type=script&lang=js&"
export * from "./common-yzm.vue?vue&type=script&lang=js&"
import style0 from "./common-yzm.vue?vue&type=style&index=0&id=1c14ade0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c14ade0",
  null
  
)

export default component.exports